import { createFrameworkSelectionStep, createRecipientSelectionStep, createMultiSelectEmployeeSelectionStep, createBodyLanguageFrameworkSelectionStep, createWrittenMessagesSelectionStep, createVerbalExpressionsSelectionStep, createAdditionalEffectsSelectionStep, } from '../shared-steps.js';
import { InteractionType } from '../../interactions/interactions.type.js';
import { FeedbackReasonOptions } from '../reason-selection-constants.js';
export const feedbackWizardFlow = {
    id: 'feedback-questions-wizard',
    title: 'wizard:feedbackQuestions.title',
    description: 'wizard:feedbackQuestions.description',
    firstStepId: 'employee-selection',
    steps: [
        // Step 1: Employee Selection
        {
            id: 'employee-selection',
            title: 'wizard:questions.firstQuestion.title',
            component: {
                id: 'EmployeeSelection',
                props: {
                    options: {
                        type: 'fetch',
                        data: 'fetch-employees',
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                    placeholder: {
                        type: 'static',
                        data: 'wizard:questions.firstQuestion.placeholder',
                    },
                },
            },
            nextStep: 'date-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:questions.firstQuestion.validation';
                return null;
            },
        },
        // Step 2: Date Selection
        {
            id: 'date-selection',
            title: 'wizard:questions.dateSelection.title',
            component: {
                id: 'DateSelection',
                props: {
                    maxDate: {
                        type: 'static',
                        data: new Date(),
                    },
                },
            },
            nextStep: 'reason-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:questions.dateSelection.validation';
                return null;
            },
        },
        // Step 3: Reason Selection - Main categories of feedback
        {
            id: 'reason-selection',
            title: 'wizard:feedbackQuestions.reasonSelection.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: FeedbackReasonOptions.COLLABORATION_SERVICE,
                                title: 'wizard:feedbackQuestions.reasonSelection.options.collaboration.title',
                                icon: '👥',
                            },
                            {
                                id: FeedbackReasonOptions.SCHEDULE_AGREEMENT,
                                title: 'wizard:feedbackQuestions.reasonSelection.options.scheduleAgreement.title',
                                icon: '📅',
                            },
                            {
                                id: FeedbackReasonOptions.COMMUNICATION,
                                title: 'wizard:feedbackQuestions.reasonSelection.options.communication.title',
                                icon: '💬',
                            },
                            {
                                id: FeedbackReasonOptions.INFORMATION_SHARING,
                                title: 'wizard:feedbackQuestions.reasonSelection.options.informationSharing.title',
                                icon: 'ℹ️',
                            },
                            {
                                id: FeedbackReasonOptions.PRAISE_FEEDBACK,
                                title: 'wizard:feedbackQuestions.reasonSelection.options.praiseFeedback.title',
                                icon: '👍',
                            },
                            {
                                id: FeedbackReasonOptions.EXPECTATIONS_SETTING,
                                title: 'wizard:feedbackQuestions.reasonSelection.options.meetingExpectations.title',
                                icon: '🎯',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (answer) => {
                // Dynamic routing based on reason selection
                switch (answer[0]) {
                    case FeedbackReasonOptions.COLLABORATION_SERVICE:
                        return 'collaboration-service-type';
                    case FeedbackReasonOptions.SCHEDULE_AGREEMENT:
                        return 'schedule-agreement-type';
                    case FeedbackReasonOptions.COMMUNICATION:
                        return 'communication-type-selection';
                    case FeedbackReasonOptions.INFORMATION_SHARING:
                        return 'information-sharing-subject-selection';
                    case FeedbackReasonOptions.PRAISE_FEEDBACK:
                        return 'praise-feedback-subject-selection';
                    case FeedbackReasonOptions.EXPECTATIONS_SETTING:
                        return 'expectations-setting-subject-selection';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:questions.reasonSelection.validation';
                return null;
            },
        },
        // Step 4a: Praise/Feedback Subject Selection
        {
            id: 'praise-feedback-subject-selection',
            title: 'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'praise-expected-not-received',
                                title: 'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.praiseExpectedNotReceived.title',
                                description: 'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.praiseExpectedNotReceived.description',
                            },
                            {
                                id: 'feedback-expected-not-received',
                                title: 'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.feedbackExpectedNotReceived.title',
                                description: 'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.feedbackExpectedNotReceived.description',
                            },
                            {
                                id: 'inappropriate-feedback-received',
                                title: 'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.inappropriateFeedbackReceived.title',
                                description: 'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.inappropriateFeedbackReceived.description',
                            },
                            // {
                            //   id: 'praise-unclear-received',
                            //   title:
                            //     'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.praiseUnclearReceived.title',
                            //   description:
                            //     'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.praiseUnclearReceived.description',
                            // },
                            // {
                            //   id: 'feedback-unclear-received',
                            //   title:
                            //     'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.feedbackUnclearReceived.title',
                            //   description:
                            //     'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.feedbackUnclearReceived.description',
                            // },
                            // {
                            //   id: 'praise-feedback-expected-not-received',
                            //   title:
                            //     'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.praiseFeedbackExpectedNotReceived.title',
                            //   description:
                            //     'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.praiseFeedbackExpectedNotReceived.description',
                            // },
                            // {
                            //   id: 'praise-feedback-unclear-received',
                            //   title:
                            //     'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.praiseFeedbackUnclearReceived.title',
                            //   description:
                            //     'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.options.praiseFeedbackUnclearReceived.description',
                            // },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 1,
                    },
                },
            },
            nextStep: 'praise-feedback-recipient-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.praiseFeedbackSubjectSelection.validation';
                return null;
            },
        },
        // Praise/Feedback Recipient Selection Step
        createRecipientSelectionStep('praise-feedback-recipient-selection', 'praise-feedback-employee-selection', // next step if "employees" is selected
        'praise-feedback-subject-description', // next step if "me" is selected
        'wizard:feedbackQuestions.praiseFeedbackRecipient.title'),
        // Praise/Feedback Employee Selection Step (multi-select)
        createMultiSelectEmployeeSelectionStep('praise-feedback-employee-selection', 'praise-feedback-subject-description' // next step after selecting employees
        ),
        // Praise/Feedback Subject Description Step (text area)
        {
            id: 'praise-feedback-subject-description',
            title: 'wizard:feedbackQuestions.praiseFeedbackSubjectDescription.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: (_answer, allAnswers) => {
                const feedbackSubject = allAnswers?.['praise-feedback-subject-selection']?.[0];
                if (feedbackSubject === 'praise-expected-not-received' ||
                    feedbackSubject === 'feedback-expected-not-received') {
                    return 'goal-selection';
                }
                return 'communication-type-selection';
            },
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.praiseFeedbackSubjectDescription.validation';
                return null;
            },
        },
        // Step 4b: Information Sharing Subject Selection
        {
            id: 'information-sharing-subject-selection',
            title: 'wizard:feedbackQuestions.informationSharingSubjectSelection.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'decision-making-involvement',
                                title: 'wizard:feedbackQuestions.informationSharingSubjectSelection.options.decisionMakingInvolvement.title',
                                description: 'wizard:feedbackQuestions.informationSharingSubjectSelection.options.decisionMakingInvolvement.description',
                            },
                            {
                                id: 'reporting',
                                title: 'wizard:feedbackQuestions.informationSharingSubjectSelection.options.reporting.title',
                                description: 'wizard:feedbackQuestions.informationSharingSubjectSelection.options.reporting.description',
                            },
                            {
                                id: 'other-information-sharing',
                                title: 'wizard:feedbackQuestions.informationSharingSubjectSelection.options.otherInformationSharing.title',
                                description: 'wizard:feedbackQuestions.informationSharingSubjectSelection.options.otherInformationSharing.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 1,
                    },
                },
            },
            nextStep: (answer) => {
                switch (answer[0]) {
                    case 'decision-making-involvement':
                        return 'decision-making-feedback-subject';
                    case 'reporting':
                        return 'reporting-feedback-subject';
                    case 'other-information-sharing':
                        return 'other-information-feedback-subject';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.informationSharingSubjectSelection.validation';
                return null;
            },
        },
        // Decision Making Feedback Subject Selection
        {
            id: 'decision-making-feedback-subject',
            title: 'wizard:feedbackQuestions.decisionMakingFeedbackSubject.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'decision-not-involving',
                                title: 'wizard:feedbackQuestions.decisionMakingFeedbackSubject.options.decisionNotInvolving.title',
                                description: 'wizard:feedbackQuestions.decisionMakingFeedbackSubject.options.decisionNotInvolving.description',
                            },
                            {
                                id: 'partial-decision-involving',
                                title: 'wizard:feedbackQuestions.decisionMakingFeedbackSubject.options.partialDecisionInvolving.title',
                                description: 'wizard:feedbackQuestions.decisionMakingFeedbackSubject.options.partialDecisionInvolving.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 1,
                    },
                },
            },
            nextStep: 'decision-making-details',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.decisionMakingFeedbackSubject.validation';
                return null;
            },
        },
        // Decision Making Details Step
        {
            id: 'decision-making-details',
            title: 'wizard:feedbackQuestions.decisionMakingDetails.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: (_answer, allAnswers) => {
                if (allAnswers?.['decision-making-feedback-subject']?.[0] ===
                    'partial-decision-involving') {
                    return 'body-language-framework-selection';
                }
                return 'goal-selection';
            },
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.decisionMakingDetails.validation';
                return null;
            },
        },
        // Reporting Feedback Subject Selection
        {
            id: 'reporting-feedback-subject',
            title: 'wizard:feedbackQuestions.reportingFeedbackSubject.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'report-not-received',
                                title: 'wizard:feedbackQuestions.reportingFeedbackSubject.options.reportNotReceived.title',
                                description: 'wizard:feedbackQuestions.reportingFeedbackSubject.options.reportNotReceived.description',
                            },
                            {
                                id: 'report-received-late',
                                title: 'wizard:feedbackQuestions.reportingFeedbackSubject.options.reportReceivedLate.title',
                                description: 'wizard:feedbackQuestions.reportingFeedbackSubject.options.reportReceivedLate.description',
                            },
                            {
                                id: 'report-partial-received',
                                title: 'wizard:feedbackQuestions.reportingFeedbackSubject.options.reportPartialReceived.title',
                                description: 'wizard:feedbackQuestions.reportingFeedbackSubject.options.reportPartialReceived.description',
                            },
                            {
                                id: 'report-received-after-others',
                                title: 'wizard:feedbackQuestions.reportingFeedbackSubject.options.reportReceivedAfterOthers.title',
                                description: 'wizard:feedbackQuestions.reportingFeedbackSubject.options.reportReceivedAfterOthers.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 1,
                    },
                },
            },
            nextStep: 'reporting-details',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.reportingFeedbackSubject.validation';
                return null;
            },
        },
        // Reporting Details Step
        {
            id: 'reporting-details',
            title: 'wizard:feedbackQuestions.reportingDetails.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: (_answer, allAnswers) => {
                if (allAnswers?.['reporting-feedback-subject']?.[0] ==
                    'report-not-received') {
                    return 'goal-selection';
                }
                return 'general-framework-selection';
            },
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.reportingDetails.validation';
                return null;
            },
        },
        // General Framework Step (used by reporting, other-information, service, communication flows)
        createFrameworkSelectionStep('general-framework-selection', 'goal-selection', 'feedback'),
        createBodyLanguageFrameworkSelectionStep('goal-selection'),
        createWrittenMessagesSelectionStep('goal-selection'),
        createVerbalExpressionsSelectionStep('goal-selection'),
        // Other Information Feedback Subject Selection
        {
            id: 'other-information-feedback-subject',
            title: 'wizard:feedbackQuestions.otherInformationFeedbackSubject.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'information-not-received',
                                title: 'wizard:feedbackQuestions.otherInformationFeedbackSubject.options.informationNotReceived.title',
                                description: 'wizard:feedbackQuestions.otherInformationFeedbackSubject.options.informationNotReceived.description',
                            },
                            {
                                id: 'information-partial-received',
                                title: 'wizard:feedbackQuestions.otherInformationFeedbackSubject.options.informationPartialReceived.title',
                                description: 'wizard:feedbackQuestions.otherInformationFeedbackSubject.options.informationPartialReceived.description',
                            },
                            {
                                id: 'information-received-delayed',
                                title: 'wizard:feedbackQuestions.otherInformationFeedbackSubject.options.informationReceivedDelayed.title',
                                description: 'wizard:feedbackQuestions.otherInformationFeedbackSubject.options.informationReceivedDelayed.description',
                            },
                            {
                                id: 'information-received-after-others',
                                title: 'wizard:feedbackQuestions.otherInformationFeedbackSubject.options.informationReceivedAfterOthers.title',
                                description: 'wizard:feedbackQuestions.otherInformationFeedbackSubject.options.informationReceivedAfterOthers.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 1,
                    },
                },
            },
            nextStep: (currentAnswer) => {
                if (currentAnswer[0] === 'information-not-received') {
                    return 'other-information-details-no-framework';
                }
                return 'other-information-details';
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.otherInformationFeedbackSubject.validation';
                return null;
            },
        },
        // Other Information Details Step
        {
            id: 'other-information-details',
            title: 'wizard:feedbackQuestions.otherInformationDetails.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: 'general-framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.otherInformationDetails.validation';
                return null;
            },
        },
        // Other Information Details Step (No Framework) - for information-not-received
        {
            id: 'other-information-details-no-framework',
            title: 'wizard:feedbackQuestions.otherInformationDetails.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: 'goal-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.otherInformationDetails.validation';
                return null;
            },
        },
        // Step 4c: Expectations Setting Subject Selection
        {
            id: 'expectations-setting-subject-selection',
            title: 'wizard:feedbackQuestions.expectationsSettingSubjectSelection.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'partial-expectations-set',
                                title: 'wizard:feedbackQuestions.expectationsSettingSubjectSelection.options.partialExpectationsSet.title',
                                description: 'wizard:feedbackQuestions.expectationsSettingSubjectSelection.options.partialExpectationsSet.description',
                            },
                            {
                                id: 'no-expectations-set',
                                title: 'wizard:feedbackQuestions.expectationsSettingSubjectSelection.options.noExpectationsSet.title',
                                description: 'wizard:feedbackQuestions.expectationsSettingSubjectSelection.options.noExpectationsSet.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 1,
                    },
                },
            },
            nextStep: (answer) => {
                if (answer[0] === 'partial-expectations-set') {
                    return 'expectations-setting-details-with-framework';
                }
                return 'expectations-setting-details-no-framework';
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.expectationsSettingSubjectSelection.validation';
                return null;
            },
        },
        // Expectations Setting Details Step (with framework) - for partial-expectations-set
        {
            id: 'expectations-setting-details-with-framework',
            title: 'wizard:feedbackQuestions.expectationsSettingDetails.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: 'general-framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.expectationsSettingDetails.validation';
                return null;
            },
        },
        // Expectations Setting Details Step (no framework) - for no-expectations-set
        {
            id: 'expectations-setting-details-no-framework',
            title: 'wizard:feedbackQuestions.expectationsSettingDetails.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: 'goal-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.expectationsSettingDetails.validation';
                return null;
            },
        },
        // Step 4d: Collaboration/Service Type Selection
        {
            id: 'collaboration-service-type',
            title: 'wizard:feedbackQuestions.collaborationServiceType.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'service-not-received',
                                title: 'wizard:feedbackQuestions.collaborationServiceType.options.serviceNotReceived.title',
                                description: 'wizard:feedbackQuestions.collaborationServiceType.options.serviceNotReceived.description',
                                icon: '❌',
                            },
                            {
                                id: 'service-received',
                                title: 'wizard:feedbackQuestions.collaborationServiceType.options.serviceReceived.title',
                                description: 'wizard:feedbackQuestions.collaborationServiceType.options.serviceReceived.description',
                                icon: '✅',
                            },
                            {
                                id: 'collaboration-not-happened',
                                title: 'wizard:feedbackQuestions.collaborationServiceType.options.collaborationNotHappened.title',
                                description: 'wizard:feedbackQuestions.collaborationServiceType.options.collaborationNotHappened.description',
                                icon: '❌',
                            },
                            {
                                id: 'collaboration-happened',
                                title: 'wizard:feedbackQuestions.collaborationServiceType.options.collaborationHappened.title',
                                description: 'wizard:feedbackQuestions.collaborationServiceType.options.collaborationHappened.description',
                                icon: '✅',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (answer) => {
                switch (answer[0]) {
                    case 'service-not-received':
                    case 'service-received':
                    case 'collaboration-not-happened':
                    case 'collaboration-happened':
                        return 'collaboration-service-description';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.collaborationServiceType.validation';
                return null;
            },
        },
        // Step 4b: Schedule/Agreement Type Selection
        {
            id: 'schedule-agreement-type',
            title: 'wizard:feedbackQuestions.scheduleAgreementType.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'goal-not-met',
                                title: 'wizard:feedbackQuestions.scheduleAgreementType.options.goalNotMet.title',
                                description: 'wizard:feedbackQuestions.scheduleAgreementType.options.goalNotMet.description',
                                icon: '🎯',
                            },
                            {
                                id: 'schedule-not-kept',
                                title: 'wizard:feedbackQuestions.scheduleAgreementType.options.scheduleNotKept.title',
                                description: 'wizard:feedbackQuestions.scheduleAgreementType.options.scheduleNotKept.description',
                                icon: '⏰',
                            },
                            {
                                id: 'agreement-not-kept',
                                title: 'wizard:feedbackQuestions.scheduleAgreementType.options.agreementNotKept.title',
                                description: 'wizard:feedbackQuestions.scheduleAgreementType.options.agreementNotKept.description',
                                icon: '❌',
                            },
                            {
                                id: 'procedure-not-followed',
                                title: 'wizard:feedbackQuestions.scheduleAgreementType.options.procedureNotFollowed.title',
                                description: 'wizard:feedbackQuestions.scheduleAgreementType.options.procedureNotFollowed.description',
                                icon: '❌',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (answer) => {
                switch (answer[0]) {
                    case 'goal-not-met':
                    case 'schedule-not-kept':
                    case 'agreement-not-kept':
                    case 'procedure-not-followed':
                        return 'schedule-agreement-description';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.scheduleAgreementType.validation';
                return null;
            },
        },
        // Step 4c: Communication Type Selection
        {
            id: 'communication-type-selection',
            title: 'wizard:feedbackQuestions.communicationType.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'verbal-expressions',
                                title: 'wizard:feedbackQuestions.communicationType.options.verbalExpressions.title',
                                description: 'wizard:feedbackQuestions.communicationType.options.verbalExpressions.description',
                                icon: '💬',
                            },
                            {
                                id: 'written-messages',
                                title: 'wizard:feedbackQuestions.communicationType.options.writtenMessages.title',
                                description: 'wizard:feedbackQuestions.communicationType.options.writtenMessages.description',
                                icon: '📧',
                            },
                            {
                                id: 'body-language',
                                title: 'wizard:feedbackQuestions.communicationType.options.bodyLanguage.title',
                                description: 'wizard:feedbackQuestions.communicationType.options.bodyLanguage.description',
                                icon: '👋',
                            },
                            {
                                id: 'general-conduct',
                                title: 'wizard:feedbackQuestions.communicationType.options.generalConduct.title',
                                description: 'wizard:feedbackQuestions.communicationType.options.generalConduct.description',
                                icon: '👤',
                            },
                            {
                                id: 'speech-tone',
                                title: 'wizard:feedbackQuestions.communicationType.options.speechTone.title',
                                description: 'wizard:feedbackQuestions.communicationType.options.speechTone.description',
                                icon: '🔊',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (answer) => {
                switch (answer[0]) {
                    case 'verbal-expressions':
                        return 'verbal-expressions-description';
                    case 'written-messages':
                        return 'written-messages-description';
                    case 'body-language':
                        return 'body-language-details';
                    case 'general-conduct':
                        return 'general-conduct-details';
                    case 'speech-tone':
                        return 'speech-tone-details';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.communicationType.validation';
                return null;
            },
        },
        // Collaboration/Service Description Step (Dynamic)
        {
            id: 'collaboration-service-description',
            title: 'wizard:feedbackQuestions.collaborationServiceDescription.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: (_answer, answers) => {
                switch (answers?.['collaboration-service-type']?.[0]) {
                    case 'service-received':
                    case 'collaboration-happened':
                        return 'general-framework-selection';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.collaborationServiceDescription.validation';
                return null;
            },
        },
        // Written Messages Description Step
        {
            id: 'written-messages-description',
            title: 'wizard:feedbackQuestions.writtenMessagesDescription.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: 'written-communication-framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.writtenMessagesDescription.validation';
                return null;
            },
        },
        // Schedule Agreement Description Step (Dynamic)
        {
            id: 'schedule-agreement-description',
            title: 'wizard:feedbackQuestions.scheduleAgreementDescription.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: 'goal-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.scheduleAgreementDescription.validation';
                return null;
            },
        },
        {
            id: 'verbal-expressions-description',
            title: 'wizard:feedbackQuestions.verbalExpressionsDescription.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.FEEDBACK,
                    },
                },
            },
            nextStep: 'verbal-expressions-framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:feedbackQuestions.verbalExpressionsDescription.validation';
                return null;
            },
        },
        // Body Language Details Step
        {
            id: 'body-language-details',
            title: 'wizard:feedbackQuestions.bodyLanguageDetails.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'look-of-surprise',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.lookOfSurprise.title',
                            },
                            {
                                id: 'look-of-disrespect',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.lookOfDisrespect.title',
                            },
                            {
                                id: 'offended-look',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.offendedLook.title',
                            },
                            {
                                id: 'staring',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.staring.title',
                            },
                            {
                                id: 'angered-look',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.angeredLook.title',
                            },
                            {
                                id: 'hitting-table',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.hittingTable.title',
                            },
                            {
                                id: 'head-holding',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.headHolding.title',
                            },
                            {
                                id: 'waive-dismissal',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.waiveDismissal.title',
                            },
                            {
                                id: 'quick-sharp-movements',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.quickSharpMovements.title',
                            },
                            {
                                id: 'folded-arms',
                                title: 'wizard:feedbackQuestions.bodyLanguageDetails.options.foldedArms.title',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: 'body-language-framework-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.bodyLanguageDetails.validation';
                return null;
            },
        },
        // Speech Tone Details Step
        {
            id: 'speech-tone-details',
            title: 'wizard:feedbackQuestions.speechToneDetails.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'laughing-inappropriately',
                                title: 'wizard:feedbackQuestions.speechToneDetails.options.laughingInappropriately.title',
                            },
                            {
                                id: 'speaking-quietly',
                                title: 'wizard:feedbackQuestions.speechToneDetails.options.speakingQuietly.title',
                            },
                            {
                                id: 'speaking-fast',
                                title: 'wizard:feedbackQuestions.speechToneDetails.options.speakingFast.title',
                            },
                            {
                                id: 'sudden-voice-raise',
                                title: 'wizard:feedbackQuestions.speechToneDetails.options.suddenVoiceRaise.title',
                            },
                            {
                                id: 'snickering',
                                title: 'wizard:feedbackQuestions.speechToneDetails.options.snickering.title',
                            },
                            {
                                id: 'high-tone',
                                title: 'wizard:feedbackQuestions.speechToneDetails.options.highTone.title',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: 'verbal-expressions-framework-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.speechToneDetails.validation';
                return null;
            },
        },
        // General Conduct Details Step
        {
            id: 'general-conduct-details',
            title: 'wizard:feedbackQuestions.generalConductDetails.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'leaving-early',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.leavingEarly.title',
                            },
                            {
                                id: 'arriving-late',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.arrivingLate.title',
                            },
                            {
                                id: 'interrupting-others',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.interruptingOthers.title',
                            },
                            {
                                id: 'speaking-too-long',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.speakingTooLong.title',
                            },
                            {
                                id: 'switching-topics',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.switchingTopics.title',
                            },
                            {
                                id: 'not-focusing',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.notFocusing.title',
                            },
                            {
                                id: 'reducing-others-expression',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.reducingOthersExpression.title',
                            },
                            {
                                id: 'premature-conclusions',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.prematureConclusions.title',
                            },
                            {
                                id: 'not-involved-enough',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.notInvolvedEnough.title',
                            },
                            {
                                id: 'arguing-too-much',
                                title: 'wizard:feedbackQuestions.generalConductDetails.options.arguingTooMuch.title',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: 'body-language-framework-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.generalConductDetails.validation';
                return null;
            },
        },
        {
            id: 'goal-selection',
            title: 'wizard:feedbackQuestions.goalSelection.title',
            component: {
                id: 'GoalsChoice',
                props: {
                    options: {
                        type: 'fetch',
                        data: 'fetch-goals',
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (answer) => answer === 'no-effect' ? 'additional-effects' : 'goal-impact-range',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.goalSelection.validation';
                return null;
            },
        },
        // Goal Impact Range (using Range component with specific negative options)
        {
            id: 'goal-impact-range',
            title: 'wizard:feedbackQuestions.goalImpactRange.title',
            component: {
                id: 'Range',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'relatively-reduced',
                                title: 'wizard:feedbackQuestions.goalImpactRange.options.relativelyReduced.title',
                                value: 1,
                            },
                            {
                                id: 'significantly-reduced',
                                title: 'wizard:feedbackQuestions.goalImpactRange.options.significantlyReduced.title',
                                value: 2,
                            },
                            {
                                id: 'extremely-reduced',
                                title: 'wizard:feedbackQuestions.goalImpactRange.options.extremelyReduced.title',
                                value: 3,
                            },
                        ],
                    },
                    colorTheme: {
                        type: 'static',
                        data: 'negative',
                    },
                    autoAdvance: {
                        type: 'static',
                        data: true,
                    },
                },
            },
            nextStep: 'additional-effects',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.goalImpactRange.validation';
                return null;
            },
        },
        createAdditionalEffectsSelectionStep('feedback'),
        // Negative Effects Follow-up Step (Generic)
        {
            id: 'additional-effects-details',
            title: 'wizard:feedbackQuestions.additionalEffectsDetails.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'everyone',
                                title: 'wizard:feedbackQuestions.relationOptions.everyone',
                            },
                            {
                                id: 'recipient',
                                title: 'wizard:feedbackQuestions.relationOptions.recipient',
                            },
                            {
                                id: 'employees',
                                title: 'wizard:feedbackQuestions.relationOptions.employees',
                            },
                            {
                                id: 'customers',
                                title: 'wizard:feedbackQuestions.relationOptions.customers',
                            },
                            {
                                id: 'suppliers',
                                title: 'wizard:feedbackQuestions.relationOptions.suppliers',
                            },
                            {
                                id: 'manager',
                                title: 'wizard:feedbackQuestions.relationOptions.manager',
                            },
                            {
                                id: 'team',
                                title: 'wizard:feedbackQuestions.relationOptions.team',
                            },
                            {
                                id: 'colleagues',
                                title: 'wizard:feedbackQuestions.relationOptions.colleagues',
                            },
                            {
                                id: 'senior-management',
                                title: 'wizard:feedbackQuestions.relationOptions.seniorManagement',
                            },
                        ],
                    },
                    columns: { type: 'static', data: 2 },
                },
            },
            nextStep: 'company-values',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.additionalEffectsDetails.validation';
                return null;
            },
        },
        // Company Values Impact (similar to praise wizard)
        {
            id: 'company-values',
            title: 'wizard:feedbackQuestions.companyValues.title',
            component: {
                id: 'CompanyValuesChoice',
                props: {
                    options: {
                        type: 'fetch',
                        data: 'fetch-company-values',
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: undefined,
            validation: (answer) => {
                if (!answer)
                    return 'wizard:feedbackQuestions.companyValues.validation';
                return null;
            },
        },
    ],
};
